import { render, staticRenderFns } from "./SignUpConfirmCode.vue?vue&type=template&id=12b6c289&scoped=true"
import script from "./SignUpConfirmCode.vue?vue&type=script&lang=ts"
export * from "./SignUpConfirmCode.vue?vue&type=script&lang=ts"
import style0 from "./SignUpConfirmCode.vue?vue&type=style&index=0&id=12b6c289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6c289",
  null
  
)

export default component.exports